var _mask, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssignDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.93652 36.2734H38.0216V43.5366C38.0216 44.6412 37.1262 45.5366 36.0216 45.5366H11.9365C10.832 45.5366 9.93652 44.6412 9.93652 43.5366V36.2734Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9574 36.2737V42C38.9574 44.2091 37.1666 46 34.9574 46H13C10.7909 46 9 44.2091 9 42V6C9 3.79086 10.7909 2 13 2H34.9574C37.1666 2 38.9574 3.79086 38.9574 6V31.1789",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.395 27.79C20.3183 27.79 17 24.4717 17 20.395C17 16.3182 20.3183 13 24.395 13C28.4718 13 31.7901 16.3183 31.7901 20.395C31.7901 24.4718 28.4718 27.79 24.395 27.79Z",
    fill: "#E9F0FF",
    stroke: "#256BFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8525 23.3944C23.5967 23.3944 23.3409 23.2969 23.1458 23.1017L20.4353 20.3912C20.045 20.0009 20.045 19.3681 20.4353 18.9777C20.8256 18.5874 21.4584 18.5874 21.8487 18.9777L23.8525 20.9815L26.9416 17.8923C27.3319 17.502 27.9647 17.502 28.355 17.8923C28.7454 18.2826 28.7453 18.9154 28.355 19.3058L24.5593 23.1016C24.364 23.2969 24.1082 23.3944 23.8525 23.3944Z",
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6387 40.905H25.8514",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 36.2734H38.9574",
    stroke: "#256BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignDevices);
export default __webpack_public_path__ + "static/media/assign_devices.ba9afded295d2e851e376188afbbd983.svg";
export { ForwardRef as ReactComponent };